export default __webpack_public_path__ + "static/media/added-favourite-black.748170ea.svg";